import { PType } from './aui'
import * as React from 'react'
import { connect } from 'react-redux'
import { IDetailPageState } from '../reducers'
import { Logger } from 'DVWebNodeUtils'
import { refreshMainActionBox, refreshEpisode } from '../actions/wps'
import { playbackIdToCanonicalIdSelector, playerConfigDataSelector, whisperCacheDataSelector } from '../selectors/player'
import { onPlayerEvent, initializePlayer } from './player/index'
import { isMovieSelector } from '../selectors/detailFragment'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'


type PrepareConfig = {
  trailer: boolean,
  ref: string,
  videoType: string,
  asin: WpsRuntime.atv.wps.TitleID,
  position: number,
  useFullView: boolean
}

interface POpts {
  asin: string;
  trailer: boolean;
}

interface Player {
  on: (event: string, callback: (_: POpts) => void) => void,
  play: () => void,
  prepare: (config: PrepareConfig) => void
}

declare let window: Window & { P: PType }

// TODO: remove onPlayerClosedOrTitleChanged once DV_WEB_DP_NODE_PLAYER_233310 dialled up
export const onPlayerClosedOrTitleChanged = (playerRefreshCallback: (_: string) => void) => {
  const handlePlayerClosedOrTitleChanged = (opts: POpts) => {
    if (opts && !opts.trailer && opts.asin) {
      playerRefreshCallback(opts.asin)
    }
  }

  // TODO: log error when "dv-player-integration" doesn't resolve
  // https://i.amazon.com/issues/AVWebDetailPage-3043
  if (window.P) {
    window.P.when('dv-player-integration').execute((auiPlayer: Player) => {
      auiPlayer.on('closed', handlePlayerClosedOrTitleChanged)
      auiPlayer.on('asinChanged', handlePlayerClosedOrTitleChanged)
    })
  }
}

// TODO: remove onPlayerCapabilities once DV_WEB_DP_NODE_PLAYER_233310 dialled up
export interface PlayerCapabilities {
  supportsWebPlayback: boolean
  supportsHDMovies: boolean
}

interface PlayerCapabilitiesWrapper {
  capabilities: PlayerCapabilities
}

export const onPlayerCapabilities = (
  callback: (capabilities: PlayerCapabilities) => void,
  logger: Logger
) => {
  if (!window.P) {
    logger.error('P is missing')
    return
  }
  window.P.when('dv-web-player-capabilities').execute(
    (
      onCapabilities: (
        callback: (pc: PlayerCapabilitiesWrapper) => void
      ) => void
    ) => {
      onCapabilities(pc => {
        if (pc && pc.capabilities) {
          callback(pc.capabilities)
        }
      })
    }
  )
}

type PlayerIntegrationProp = {
  pageTitleId: string
}

type PlayerIntegrationConnectedProps = PlayerIntegrationProp & ReturnType<typeof mapStateToProps>
export class PlayerIntegrationConnected extends React.Component<PlayerIntegrationConnectedProps> {

  attachRefreshEventHandlers() {
    const { usePlayer } = this.props

    const refreshAfterPlayback = (titleId: string) => {
      const { canonicalTitleIdMap, pageTitleId, isMovie } = this.props

      const canonicalTitleId = canonicalTitleIdMap && canonicalTitleIdMap[titleId] || titleId
      const refreshAfterPlaybackArgs = {
        canonicalTitleId,
        pageTitleId
      }
      refreshAfterPlaybackDispatcher(isMovie)(refreshAfterPlaybackArgs)
    }

    const handlePlayerClosedOrTitleChanged = (opts: POpts) => {
      if (opts && !opts.trailer && opts.asin) {
        refreshAfterPlayback(opts.asin)
      }
    }

    if (usePlayer) {
      onPlayerEvent('closed', handlePlayerClosedOrTitleChanged)
      onPlayerEvent('asinChanged', handlePlayerClosedOrTitleChanged)
    } else {
      onPlayerClosedOrTitleChanged(refreshAfterPlayback)
    }
  }

  componentDidMount() {
    const { usePlayer, playerConfigData, whisperCacheData } = this.props

    if (usePlayer) {
      const player = initializePlayer(playerConfigData)

      if (whisperCacheData) {
        player.prepare(whisperCacheData)
      }
    }

    this.attachRefreshEventHandlers()
  }

  render(): null {
    return null
  }
}

const mapStateToProps = (state: IDetailPageState) => ({
  pageTitleId: state.pageTitleId,
  canonicalTitleIdMap: playbackIdToCanonicalIdSelector(state),
  isMovie: isMovieSelector(state),
  usePlayer: state.features.usePlayer,
  playerConfigData: playerConfigDataSelector(state),
  whisperCacheData: whisperCacheDataSelector(state),
})




type RefreshAfterPlayback = {
  pageTitleId: string,
  canonicalTitleId: string
}
export const refreshAfterPlaybackDispatcher = (isMovie: boolean) => ({ pageTitleId, canonicalTitleId }: RefreshAfterPlayback) => {

  refreshMainActionBox(pageTitleId, canonicalTitleId, canonicalTitleId)
  if (!isMovie) {
    refreshEpisode(canonicalTitleId)
  }
}


export const PlayerIntegration = connect(mapStateToProps)(PlayerIntegrationConnected)
